/**
 * MoonshotPage — the route entry point for `/moonshot`.
 *
 * Wraps the voice chat UI in a DemoMockProvider with `forceEnabled`. This
 * lets the `/moonshot` route render the demo even if the URL didn't carry
 * `?mode=moonshot`, while still respecting `?journey=N` and `&hud=off`.
 */

import React from 'react';
import { DemoMockProvider } from './DemoMockProvider';
import MoonshotVoiceChat from './components/MoonshotVoiceChat';

const MoonshotPage: React.FC = () => {
  return (
    <DemoMockProvider forceEnabled>
      <MoonshotVoiceChat />
    </DemoMockProvider>
  );
};

export default MoonshotPage;
